import {
  Button,
  ButtonGroup,
  COLORS,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@podiumhq/design-system';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

export const EditModalWrapper = ({
  children,
  handleSave,
  headerTitle,
  isOpen,
  isSaving,
  onClose,
}) => {
  const { isMobile } = useCheckoutContext();

  const buttonGroupStyles = {
    __css: {
      button: {
        boxShadow: 'none',
      },
    },
    ...(isMobile && {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column-reverse',
      justifyContent: 'center',
      width: '100%',
    }),
  };
  const buttonStyles = {
    boxShadow: 'none',
    outline: 'none',
    ...(isMobile && { width: '100%' }),
  };
  const cancelButtonStyles = {
    ...buttonStyles,
    ...(isMobile && {
      border: 'none',
      color: 'blue.base',
      my: '14px',
    }),
  };
  const modalBodyStyles = {
    margin: '0',
  };
  const modalContentStyles = isMobile
    ? {
        bottom: 0,
        marginBottom: '0',
        position: 'absolute',
      }
    : {};

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      motionPreset={isMobile ? 'slideInBottom' : 'scale'}
      size="md"
    >
      <ModalOverlay />

      <ModalContent {...modalContentStyles}>
        {headerTitle && (
          <ModalHeader mr={isMobile ? '42px' : '8px'}>
            {headerTitle}
          </ModalHeader>
        )}
        {isMobile && (
          <ModalCloseButton
            isDisabled={isSaving}
            sx={{ mt: '0', svg: { fill: COLORS.grey.lighter } }}
          />
        )}

        <ModalBody {...modalBodyStyles}>{children}</ModalBody>

        <ModalFooter>
          <ButtonGroup
            isDisabled={isSaving}
            size="md"
            spacing={isMobile ? 0 : 4}
            {...buttonGroupStyles}
          >
            <Button onClick={onClose} variant="outline" {...cancelButtonStyles}>
              Cancel
            </Button>
            <Button
              fillColor="blue.base"
              isLoading={isSaving}
              onClick={handleSave}
              variant="primary"
              {...buttonStyles}
            >
              Save
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
